import createAxios from 'config/axios'

export const getYearsIncomeReport = () => //eslint-disable-line
  createAxios.get('mufasa/reportIncome/years')

